import { Routes, Route, Navigate } from 'react-router-dom';
import { modelVersions } from './services/constants';
import MainLayout from './components/MainLayout';
import ModelView from './components/ModelView';
import ReactTooltip from 'react-tooltip';
import { StoreProvider } from './store/useStore';

function App() {
    return (
        <Routes>
            <Route path="/:company?">
                <Route
                    path="substraatteelt"
                    element={
                        <StoreProvider modelVersion={modelVersions.substraat}>
                            <MainLayout modelVersion={modelVersions.substraat}>
                                <ModelView
                                    modelVersion={modelVersions.substraat}
                                />
                            </MainLayout>
                        </StoreProvider>
                    }
                ></Route>

                <Route
                    path="potplanten"
                    element={
                        <StoreProvider modelVersion={modelVersions.potplant}>
                            <MainLayout modelVersion={modelVersions.potplant}>
                                <ModelView
                                    modelVersion={modelVersions.potplant}
                                />
                            </MainLayout>
                        </StoreProvider>
                    }
                ></Route>

                <Route
                    path="test"
                    element={
                        <div style={{ padding: 30 }}>
                            <h1>test</h1>
                            <p
                                data-tip="tooltip"
                                data-for="tooltip"
                                style={{
                                    background: '#00000011',
                                    padding: '4px 16px',
                                    width: 'fit-content',
                                }}
                            >
                                tip
                            </p>
                            <ReactTooltip id="tooltip"></ReactTooltip>
                        </div>
                    }
                ></Route>

                <Route
                    path=""
                    element={<Navigate to="./substraatteelt" replace />}
                />
            </Route>
        </Routes>
    );
}

export default App;
